import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteIcon from '@mui/icons-material/DeleteOutlineOutlined';
import BackButton from './BackButton';
import AddButton from './AddButton';
import CustomButton from './CustomButton';

const PageHeader = ({
  onBack,
  backText,
  title,
  onEdit,
  onDelete,
  onAdd,
  onReactivate,
  reactivateDisabled,
  reactivateLoading,
}) => {
  return (
    <>
      <Box
        padding="1rem"
        display="flex"
        justifyContent="space-between"
        alignItems="center">
        <Box flex={1}>
          {onBack && <BackButton text={backText || 'Back'} onClick={onBack} />}
        </Box>
        {title && (
          <Typography variant="h5" fontWeight="bold">
            {title}
          </Typography>
        )}
        <Box
          display="flex"
          alignItems="center"
          flex={1}
          justifyContent="flex-end"
          gap="1rem">
          {onReactivate && (
            <CustomButton
              disabled={reactivateDisabled}
              onClick={onReactivate}
              loading={reactivateLoading}>
              Reactivate for 24h
            </CustomButton>
          )}
          {onEdit && (
            <IconButton onClick={onEdit}>
              <ModeEditIcon />
            </IconButton>
          )}
          {onDelete && (
            <IconButton onClick={onDelete}>
              <DeleteIcon />
            </IconButton>
          )}
          {onAdd && <AddButton onClick={onAdd} />}
        </Box>
      </Box>
      <Divider />
    </>
  );
};

export default PageHeader;
